/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Appointment/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Booking from './Booking/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2PlusIcon from 'DesignSystem/Svgs/Tysiav2PlusIcon/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Appointment({
  children,
  closePopover,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/AppointmentSelect/Content/Content/Content/Content/Appointments/Appointment"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let appointmentOverlayAppointmentIdValueData = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'appointment_id',
})
let appointmentIdValueData = fromData.useDataValue({ viewPath,
context: 'appointment',
path: '_id',
})
let aggregateData = fromAggregate.equals(appointmentOverlayAppointmentIdValueData, appointmentIdValueData)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let onClick = fromHelpers.useOnClick({
  children,
  closePopover,
  viewPath,
  isHovered
  
})
let constantData = 'new'
let appointmentIdValueData1 = fromData.useDataValue({ viewPath,
context: 'appointment',
path: 'id',
})
let aggregateData1 = fromAggregate.equals(constantData, appointmentIdValueData1)
let dtColorsGreen600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.600'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let constantData1 = 'new'
let appointmentIdValueData2 = fromData.useDataValue({ viewPath,
context: 'appointment',
path: 'id',
})
let aggregateData2 = fromAggregate.not(constantData1, appointmentIdValueData2)
let appointmentTypeDisplayNameValueData = fromData.useDataValue({ viewPath,
context: 'appointment',
path: 'type.display_name',
})
let appointmentGroupValueData = fromData.useDataValue({ viewPath,
context: 'appointment',
path: 'group',
})
  return (<React.Fragment
>
<button
  data-testid="Appointment.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--pt-1-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-2-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pl-3-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pr-4-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-5-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-6-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bblr-7-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-8-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-9-dUIJ5': isHovered ? dtColorsNeutral100 : aggregateData ? dtColorsNeutral100 : "initial"}}
 className={`views-block ${styles.Horizontal}`}
>
<fromFlow.When is={aggregateData1}>
<div
  data-testid="Appointment.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<div
  data-testid="Appointment.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Tysiav2PlusIcon
  viewPath={`${viewPath}/Tysiav2PlusIcon`}
 height={12}
 width={12}
 fill2={dtColorsGreen600}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceXs}
 weight="medium"
 color={dtColorsGreen600}
 text="New appointment"
/>
</div>
</div>
</fromFlow.When>
<div
  data-testid="Appointment.Vertical:1"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="appointment.type.display_name"
 text={appointmentTypeDisplayNameValueData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="appointment.group"
 text={appointmentGroupValueData}
/>
<Booking
  viewPath={`${viewPath}/Booking`}
/>
</div>
</button>
{children}
</React.Fragment>)
}